var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as Long from "long";
import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { selectCurrentActionButton } from "../../selectors/selectActionButtonInfo";
import { selectPendingInventoryActionInfo, selectPendingInventoryByActionButtonId, selectPendingInventoryRewardsIconInfo, } from "../../selectors/selectPendingInventoryInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { PendingInventoryType } from "../../utils/network/generated/protoTypes";
import { utilPager } from "../../utils/utilPager";
import { BigCharacter } from "../generic/big-character/BigCharacter";
import { IdBigCharacter } from "../generic/big-character/IdBigCharacter";
import { ButtonPagerLeft } from "../generic/common/ButtonPagerLeft";
import { ButtonPagerRight } from "../generic/common/ButtonPagerRight";
import { ButtonPrimary } from "../generic/common/ButtonPrimary";
import { Icon } from "../generic/icon/Icon";
import { List } from "../generic/list/List";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { Pager } from "../generic/pager/Pager";
import { TextLoca } from "../generic/text/TextLoca";
import { actionActionButtonResetIteration } from "../hud-action-button/actionHudActionButton";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { ProfilePicture } from "../player-profile/ProfilePicture";
import { TransparentDialogWrapper } from "../transparent-dialog/TransparentDialogWrapper";
import { actionPendingInventoryCollectRewards } from "./actionPendingInventoryInfo";
import { IdPendingInventoryRewardType } from "./IdPendingInventoryRewardType";
import { RewardInfo } from "./RewardInfo";
var DialogPendingInventoryDOM = /** @class */ (function (_super) {
    __extends(DialogPendingInventoryDOM, _super);
    function DialogPendingInventoryDOM() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.RewardsPerPage = 3;
        _this.getPager = function () {
            var pendingInventoryResources = _this.props.pendingInventoryResources;
            if (pendingInventoryResources === undefined) {
                return React.createElement(React.Fragment, null);
            }
            var pageCount = Math.ceil(pendingInventoryResources.length / _this.RewardsPerPage);
            return React.createElement(Pager, { pageCount: pageCount }, _this.renderPager);
        };
        _this.renderPager = function (page, changePage) {
            var pendingInventoryResources = _this.props.pendingInventoryResources;
            if (pendingInventoryResources === undefined) {
                return React.createElement(React.Fragment, null);
            }
            var slicedItems = utilPager.getPageItemsFilled(pendingInventoryResources, page, _this.RewardsPerPage);
            return (React.createElement("div", { className: "level-up__rewards " + IdStyles.RewardDialogRewards },
                React.createElement(ButtonPagerLeft, { onClick: function () { return changePage(page - 1); } }),
                React.createElement(List, { className: "flex flex__full flex--around", items: slicedItems, renderItem: _this.renderPagerItem }),
                React.createElement(ButtonPagerRight, { onClick: function () { return changePage(page + 1); } })));
        };
        _this.renderPagerItem = function (reward, index) {
            var iconElement = reward.type === IdPendingInventoryRewardType.Picture ? (React.createElement(ProfilePicture, { profilePictureSize: IdStyles.ProfilePictureSmall, profilePictureName: reward.icon })) : (React.createElement(Icon, { icon: reward.icon, tooltipLoca: reward.tooltipLoca, styleId: IdStyles.IconExtraLarge }));
            return (React.createElement("div", { className: "reward-dialog__rewards-item", key: index },
                iconElement,
                React.createElement("div", { className: IdStyles.TextBoldAccent },
                    React.createElement(NumberFormat, { amount: reward.amount || Long.ZERO }))));
        };
        _this.onCollectRewardClick = function () {
            var _a = _this.props, onCollectRewards = _a.onCollectRewards, transferId = _a.transferId, actionButtonId = _a.actionButtonId;
            if (transferId === undefined || actionButtonId === undefined) {
                return;
            }
            onCollectRewards(transferId, actionButtonId);
        };
        return _this;
    }
    DialogPendingInventoryDOM.prototype.render = function () {
        var _a = this.props, pendingInventoryActionInfo = _a.pendingInventoryActionInfo, pendingInventoryType = _a.pendingInventoryType;
        if (pendingInventoryActionInfo === undefined) {
            return React.createElement(React.Fragment, null);
        }
        var isWelcomeBackGift = pendingInventoryType === PendingInventoryType.WELCOME_BACK_PACKAGE;
        var title = pendingInventoryActionInfo.title, description = pendingInventoryActionInfo.description;
        var character = isWelcomeBackGift
            ? IdBigCharacter.TessaLeftSide
            : IdBigCharacter.MonicaLeftSide;
        var pager = this.getPager();
        return (React.createElement(TransparentDialogWrapper, null,
            React.createElement("div", { className: "reward-dialog" },
                React.createElement(BigCharacter, { name: character, className: "reward-dialog__character" }),
                React.createElement(RewardInfo, { title: title, description: description },
                    React.createElement("div", { className: "flex flex--guts " + IdStyles.RewardDialogRewardsWrapper }, pager),
                    React.createElement(ButtonPrimary, { onClick: this.onCollectRewardClick },
                        React.createElement("div", { className: IdStyles.TextButtonHeading },
                            React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.collect })))))));
    };
    return DialogPendingInventoryDOM;
}(React.PureComponent));
var mapState = function (state) {
    var actionButtonInfo = selectCurrentActionButton(state);
    if (actionButtonInfo === undefined) {
        return {};
    }
    var actionButtonId = actionButtonInfo.id;
    var pendingInventory = selectPendingInventoryByActionButtonId(state, actionButtonId);
    var transferId = pendingInventory.transferId;
    var pendingInventoryType = pendingInventory.typeId;
    var pendingInventoryActionInfo = selectPendingInventoryActionInfo(pendingInventory.typeId);
    var pendingInventoryResources = selectPendingInventoryRewardsIconInfo(state, pendingInventory);
    return {
        actionButtonId: actionButtonId,
        pendingInventoryActionInfo: pendingInventoryActionInfo,
        pendingInventoryResources: pendingInventoryResources,
        pendingInventoryType: pendingInventoryType,
        transferId: transferId,
    };
};
var mapDispatch = function (dispatch) { return ({
    onClose: function () { return dispatch(actionModalClose(IdModal.PendingInventory)); },
    onCollectRewards: function (transferId, actionButtonId) {
        dispatch(actionPendingInventoryCollectRewards(transferId));
        dispatch(actionActionButtonResetIteration(actionButtonId));
    },
}); };
export var DialogPendingInventory = connect(mapState, mapDispatch)(DialogPendingInventoryDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/pending-inventory/DialogPendingInventory.tsx
// module id = 2855
// module chunks = 3